import React from "react";
import Hero from "../components/Home/Hero";

const Home = () => {
  return <Hero />;
};

export default Home;
